import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ConfirmationDialog } from 'acscp/components/common/confirmationDialog';

interface DeleteAccountLinkConfirmationDialogProps {
    isOpen: boolean;
    closeDialog: () => void;
    deleteAccountLink: () => void;
}

const DeleteAccountLinkConfirmationDialog: React.SFC<DeleteAccountLinkConfirmationDialogProps> =
    ({isOpen, closeDialog, deleteAccountLink}) => (
        <ConfirmationDialog
            isOpen={isOpen}
            closeDialog={closeDialog}
            modalHeaderContent={
                <FormattedMessage
                    id={'components.accountLinks.accountLink.deleteAccountLinkDialog.header'}
                    defaultMessage={'Delete account link'}
                />
            }
            confirmationContent={
                <div>
                    <FormattedMessage
                        id={'components.accountLinks.accountLink.deleteAccountLinkDialog.contentPart1'}
                        defaultMessage={'By clicking Confirm this JetPortal Account Holder\'s visibility of your quotes ' +
                        'and bookings will be removed and they will no longer have access to any of the shared items.'}
                    />
                    <br/><br/>
                    <FormattedMessage
                        id={'components.accountLinks.accountLink.deleteAccountLinkDialog.contentPart2'}
                        defaultMessage={'You can individually share enquiries, quotes and itineraries with the user ' +
                        'instead by clicking ‘Share’ on one of your enquiries and entering their email address.'}
                    />
                </div>
            }
            leftButtonContent={
                <FormattedMessage
                        id={'components.accountLinks.accountLink.deleteAccountLinkDialog.confirm'}
                        defaultMessage={'Confirm'}
                />
            }
            leftButtonGreyedOut={false}
            leftButtonOnClick={() => {
                deleteAccountLink();
                closeDialog();
            }}
            rightButtonContent={
                <FormattedMessage
                        id={'components.accountLinks.accountLink.deleteAccountLinkDialog.cancel'}
                        defaultMessage={'Cancel'}
                />
            }
            rightButtonGreyedOut={true}
            rightButtonOnClick={closeDialog}
        />
    );

export { DeleteAccountLinkConfirmationDialog };
